/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {assignVerifiedCustomerToVoiceCase} from '../api'

export const useMutationAssignVerifiedCustomerToVoiceCase = createReactQueryMutationHook('assignVerifiedCustomerToVoiceCase', assignVerifiedCustomerToVoiceCase)
